import { useEffect, useRef, useState } from 'react';

export const TRANSITION_STAGE = {
  entering: 'entering',
  entered: 'entered',
  exiting: 'exiting',
  exited: 'exited',
  appear: 'appear',
};
export const useTransition = ({ transition, duration }) => {
  const [state, setState] = useState(transition ? TRANSITION_STAGE.appear : TRANSITION_STAGE.exited);
  const isInitialRun = useRef(true);

  /* Using a mutable ref here looks like it does nothing, but it actually ensures that we don't restart the transition
  if the duration changes mid-transition */
  const durationRef = useRef(duration);
  durationRef.current = duration;

  useEffect(() => {
    if (isInitialRun.current) {
      isInitialRun.current = false;
      return;
    }

    setState(transition ? TRANSITION_STAGE.entering : TRANSITION_STAGE.exiting);
    const timeoutRef = setTimeout(() => {
      setState(transition ? TRANSITION_STAGE.entered : TRANSITION_STAGE.exited);
    }, durationRef.current);

    return () => {
      if (timeoutRef) clearTimeout(timeoutRef);
    };
  }, [transition]);

  return state;
};
